import { useContext, useState, useEffect } from 'react'

import { OptionFilterItem } from '../'
import * as S from './styled'
import { EntryKeyContext } from '../../../../context'

const MAX_NUMBER_OPTIONS_PER_HEIGHT = 4
const SCROLL_WIDTH = 13.5

const FilterTypes = ({
  filterKey,
  selected,
  filterTypeIndex,
  name = '',
  options = []
}) => {
  const [isOverflown, setIsOverflown] = useState(false)

  useEffect(() => {
    if (options.length > MAX_NUMBER_OPTIONS_PER_HEIGHT) {
      setIsOverflown(true)
    }
  }, [options.length])

  const {
    query: filtersQuery,
    isMappedSearch,
    onOptionClick,
    baseUrl
  } = useContext(EntryKeyContext)

  return (
    <S.Content fixedHeight={isOverflown} >
      {options.map(({ query, label: optionLabel, quantity }, index) => (
        <OptionFilterItem
          key={query}
          filterKey={filterKey}
          name={name}
          query={query}
          optionLabel={optionLabel}
          quantity={quantity}
          selected={selected}
          onFilterClick={onOptionClick}
          filtersQuery={filtersQuery}
          url={baseUrl}
          isMappedSearch={isMappedSearch}
          filterElementIndex={index}
          filterTypeIndex={filterTypeIndex}
          rightSpacing={!isOverflown ? SCROLL_WIDTH : 0}
        />
      ))}
    </S.Content>
  )
}

export default FilterTypes
